import { useBrand } from '@common/brand/BrandContext';
import MenuSelectOption from '@common/components/Menu/MenuSelectOption';
import IconDarkMode from '@common/components/svgs/common/DarkMode';
import IconLightMode from '@common/components/svgs/common/LightMode';
import IconSystemMode from '@common/components/svgs/common/SystemMode';
import { useDarkModeContext } from '@common/containers/ApplicationContext';
import { useFeatureFlag } from '@common/store/reducers/featureFlags';

function ColorThemesMenu() {
  const themesEnabled = useFeatureFlag('Themes');
  const { isTecalor } = useBrand();
  const { ternaryDarkMode, setTernaryDarkMode } = useDarkModeContext();

  return (themesEnabled && !isTecalor)
    ? (
      <>
        <MenuSelectOption
          id="menu.option.theme-dark"
          leadingIcon={IconDarkMode}
          onClick={() => setTernaryDarkMode('dark')}
          value="dark"
          selected={ternaryDarkMode}
          data-testid="darkModeSelect"
          firstOfGroup
        />
        <MenuSelectOption
          id="menu.option.theme-light"
          leadingIcon={IconLightMode}
          onClick={() => setTernaryDarkMode('light')}
          value="light"
          selected={ternaryDarkMode}
          data-testid="lightModeSelect"
        />
        <MenuSelectOption
          id="menu.option.theme-system"
          leadingIcon={IconSystemMode}
          onClick={() => setTernaryDarkMode('system')}
          value="system"
          selected={ternaryDarkMode}
          data-testid="systemModeSelect"
          lastOfGroup
        />
      </>
    )
    : null;
}

export default ColorThemesMenu;
